import React, { Component } from "react";
import { Button } from "reactstrap";

export default class ReadMore extends Component {
  state = { showMore: false };

  _getText = (text) => {
    if (text?.length <= 250) return(<><p>{text}</p></>);

    if (text?.length > 250 && this.state.showMore) {
      return (
        <p className="mb-0">
          {text}...
          <Button
            color="link"
            onClick={() => this.setState({ showMore: false })}
            className="readMore"
          >
            read less
          </Button>
        </p>
      );
    }

    if (text?.length > 250) {
      return (
        <p className="mb-0">
          {text?.slice(0, 250)}...
          <Button
            color="link"
            onClick={() => this.setState({ showMore: true })}
            className="readMore"
          >
            read more
          </Button>
        </p>
      );
    }
  };
  render() {
    return <>{this._getText(this.props.text)}</>;
  }
}
